<template>
  <div class="PushComponent">
        
    
    <PushFilesComponent  :lang="lang" :data="data"></PushFilesComponent>
    
 </div>
</template>

<script>

import PushFilesComponent from "@/components/shared/PushFilesComponent"
import { mapGetters } from 'vuex'
export default {
  name: 'PushComponent',
  components: {
    PushFilesComponent
  },
  props:{
    lang: Object,
    data: Object
    
  },
  data () {
    return {
      
    }
  },
  computed: {
    ...mapGetters([
      'appConf',
      
    ]),
    
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    }

  },
  created () {

    

  },
  updated() {
    
  },
  watch: {
    
  },
  methods: {
    
    
  }
  
  
}
</script>


<style lang="scss">
    
  .create-button{
    margin-left: 10px;
  }
  .list-group-item {
    padding: 0.25rem 0.25rem !important;
    
  }
  .import-file{
    width: 400px;
    margin-left: 10px;
   

  }
  .input-symbol-name{
    width: 200px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/PushComponent.vue